const homeAudiencesPath = '/app/audiences';
const homeOrganizationsPath = '/app/organizations';
const homePath = '/app/dashboard';
const conversationsPath = '/app/conversations';

export { conversationsPath, homeAudiencesPath, homeOrganizationsPath, homePath };
